import { PowerCalculator } from "./tools/power-calculator";
import { OhmsLawCalculator } from "./tools/ohms-law";
import { LedResistorCalculator } from "./tools/led-resistor";
import { BatteryLifeCalculator } from "./tools/battery-life-calculator";
import { ResistorColourCalculator } from "./tools/resistor-color";
let power = new PowerCalculator();
let ohms = new OhmsLawCalculator();
let led = new LedResistorCalculator();
let battery = new BatteryLifeCalculator();
let resistor = new ResistorColourCalculator();
